export const SET_IS_LOADING = 'ADVANCED_CONFIGS/SET_IS_LOADING';